import { CarBody } from "./CarBody";
import { CAR } from "./dimensions";
import { CAR_4_LAYOUT, CAR_4_WHEELS } from "./wheels";
const car4Preset = {
  id: "car-4",
  silhouette: "car",
  renderModelKey: "car",
  renderLayoutKey: "car-4-wheel-v1",
  label: "2 axles, single fitment",
  layout: CAR_4_LAYOUT,
  wheels: CAR_4_WHEELS,
  camera: {
    position: [4.9, 2.15, 4.5],
    target: [0, 0.72, 0],
    minDistance: 3.4,
    maxDistance: 12,
    fov: 32
  },
  stage: { extent: CAR.length, contactHeight: 1 },
  skeleton: "frame",
  Body: CarBody
};
export {
  car4Preset
};
